const BaseView = require('../components/common/common-component');
const TemplateView = require('./templates-view');
const GridView = require('../customize/contents/grids/view');

const AnalyticsDecorate = require('../../../analytics/decorate');

if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
  module.exports = require('./mode-view/templates');
} else if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN) {
  module.exports = require('./mode-view/restricted');
} else if (INKIVE.Helpers.isDesygnerProject()) {
  module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
    type: 'template',
    updateSearchContainer: $.noop,

    isAlreadyThere: function () {
      return !!this.$el.find('.tab-content.template').length;
    },

    render: async function () {
      await BaseView.prototype.render.call(this);
      this.$headerLinks.filter('[data-key=add]').trigger('click');
    },

    initAddView: function () {
      const templateView = new TemplateView({ el: this.$el.find('div.add') });
      this.registerTabView('add', templateView);
      templateView.render();
    },

    initGridView: function () {
      const gridView = new GridView({ el: this.$el.find('div.grid') });
      this.registerTabView('grid', gridView);
      this.$el.find('.thumbnail-wrapper').append('<div class="scrollDetect hide"/>');
      gridView.render();
    }
  }));
}
